"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFederatedCredentials = exports.findUserFromUserName = void 0;
const aws_sdk_1 = require("aws-sdk");
exports.default = aws_sdk_1.Connect;
const findUserFromUserName = async (connect, instanceID, username, nextPageToken) => {
    const results = await connect
        .listUsers({
        InstanceId: instanceID,
        NextToken: nextPageToken,
    })
        .promise();
    console.log(results.UserSummaryList, username);
    const user = results.UserSummaryList.find(user => user.Username === username);
    console.log(user);
    return user
        ? user
        : results.NextToken
            ? await findUserFromUserName(connect, instanceID, username, results.NextToken)
            : undefined;
};
exports.findUserFromUserName = findUserFromUserName;
const getFederatedCredentials = async (instanceID, aws, username, roleARN) => {
    const paramsRole = {
        RoleArn: roleARN,
        RoleSessionName: username,
    };
    const sts = new aws_sdk_1.STS(aws);
    const data = await sts.assumeRole(paramsRole).promise();
    if (!data || !data.Credentials) {
        throw new Error('No Credentials');
    }
    console.log('creating connect instance', data.Credentials);
    const connect = new aws_sdk_1.Connect({
        accessKeyId: data.Credentials.AccessKeyId,
        secretAccessKey: data.Credentials.SecretAccessKey,
        sessionToken: data.Credentials.SessionToken,
        region: aws.region,
    });
    console.log('get federatedToken for connect instance', instanceID);
    const federatedToken = await connect.getFederationToken({ InstanceId: instanceID }).promise();
    return federatedToken.Credentials;
};
exports.getFederatedCredentials = getFederatedCredentials;
